/* eslint-disable react/display-name */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useMemo, useState } from 'react';
import { Box } from '@tapresearch/ui/components';
import { getCustomNivoBarItem, getPortalRenderedLegend } from '@tapresearch/ui/charts';
import { ResponsiveBar } from '@nivo/bar';
import { useBreakpoint } from '../../../../../shared/Hooks';
import { useColorScheme } from '../../../project/longitudinal-results';
import { getCustomBarLabel } from './CustomBarLabel';
import { CustomBarLegends } from './CustomBarLegends';
import { getCustomCrossTabBarLabel } from './CustomCrossTabBarLabel';
import { CustomCrossTabTooltip } from './CustomCrossTabTooltip';
import { CustomTick } from './CustomTick';
import { ImageChoiceLegends } from './ImageChoiceLegends';
import { getImageTick } from './ImageChoiceTick';
export var StackedBarChart = function(param) {
    var data = param.data, tapAnswers = param.tapAnswers, isCrossTab = param.isCrossTab, usePercentage = param.usePercentage, _param_isImageChoice = param.isImageChoice, isImageChoice = _param_isImageChoice === void 0 ? false : _param_isImageChoice, legendContainerId = param.legendContainerId;
    var _useState = _sliced_to_array(useState([]), 2), hiddenIds = _useState[0], setHiddenIds = _useState[1];
    var isMd = useBreakpoint().isMd;
    var keys = isCrossTab ? tapAnswers.map(function(ta) {
        return ta.attributes.id.toString();
    }) : data.map(function(answer) {
        return answer.answer_id.toString();
    });
    var tapAnswersById = useMemo(function() {
        return tapAnswers === null || tapAnswers === void 0 ? void 0 : tapAnswers.reduce(function(acc, answer) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, answer.attributes.id.toString(), answer.attributes));
        }, {});
    }, [
        tapAnswers
    ]);
    var toggleSerie = useCallback(function(serieId) {
        var hiddenIdsSet = new Set(hiddenIds);
        if (hiddenIdsSet.has(serieId)) {
            hiddenIdsSet.delete(serieId);
        } else {
            hiddenIdsSet.add(serieId);
        }
        setHiddenIds(_to_consumable_array(hiddenIdsSet));
    }, [
        hiddenIds
    ]);
    var BarLegends = useMemo(function() {
        return getPortalRenderedLegend("#".concat(legendContainerId), isImageChoice ? ImageChoiceLegends : CustomBarLegends, {
            data: data,
            hiddenSeries: hiddenIds,
            toggleSerie: toggleSerie,
            answersById: tapAnswersById
        }, 'bars');
    }, [
        legendContainerId,
        data,
        hiddenIds,
        toggleSerie,
        tapAnswersById,
        isImageChoice
    ]);
    var CustomBarLabel = useMemo(function() {
        return getCustomBarLabel({
            usePercentage: usePercentage,
            answersById: tapAnswersById
        });
    }, [
        tapAnswersById,
        usePercentage
    ]);
    var CustomCrossTabBarLabel = useMemo(function() {
        return getCustomCrossTabBarLabel({
            usePercentage: usePercentage
        });
    }, [
        usePercentage
    ]);
    var CustomCrossTabBarComponent = useMemo(function() {
        if (isCrossTab) return getCustomNivoBarItem(CustomCrossTabBarLabel);
    }, [
        isCrossTab,
        CustomCrossTabBarLabel
    ]);
    var CustomBarComponent = useMemo(function() {
        return getCustomNivoBarItem(CustomBarLabel, {
            height: 32,
            showBarBackground: true
        });
    }, [
        CustomBarLabel
    ]);
    var LeftAxisTick = useMemo(function() {
        return getImageTick(tapAnswersById);
    }, [
        tapAnswersById
    ]);
    var filteredData = useMemo(function() {
        if (isCrossTab) {
            return data.reduce(function(acc, serieData) {
                var newSerieData = _object_spread({}, serieData);
                hiddenIds.forEach(function(hiddenId) {
                    delete newSerieData[hiddenId];
                    delete newSerieData["".concat(hiddenId, "_total")];
                });
                acc.push(newSerieData);
                return acc;
            }, []);
        }
        return data;
    }, [
        hiddenIds,
        data,
        isCrossTab
    ]);
    var colors = useColorScheme();
    return /*#__PURE__*/ React.createElement(Box, {
        w: "100%",
        h: "100%",
        overflowX: {
            base: 'scroll',
            md: 'visible'
        },
        sx: {
            svg: {
                overflow: 'visible'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, _object_spread({
        w: "100%",
        h: "100%"
    }, isCrossTab && {
        minW: '500px'
    }), /*#__PURE__*/ React.createElement(ResponsiveBar, _object_spread({
        margin: {
            top: 30,
            right: isCrossTab ? 20 : 0,
            bottom: 30,
            left: isCrossTab ? isMd ? 120 : 80 : 0
        },
        indexBy: 'answer_id',
        data: filteredData,
        keys: keys,
        colors: colors,
        maxValue: 100,
        padding: 0.25,
        axisLeft: !!isCrossTab && {
            renderTick: CustomTick
        },
        axisBottom: null,
        enableGridX: false,
        enableGridY: !!isCrossTab,
        layout: 'horizontal'
    }, !isCrossTab ? {
        label: function(d) {
            var _tapAnswersById_d_id_toString;
            return "".concat((_tapAnswersById_d_id_toString = tapAnswersById[d.id.toString()]) === null || _tapAnswersById_d_id_toString === void 0 ? void 0 : _tapAnswersById_d_id_toString.option_text, " - ").concat(d.value);
        },
        axisLeft: isImageChoice ? {
            renderTick: LeftAxisTick
        } : false,
        barComponent: CustomBarComponent,
        colors: [
            '#99DBD4'
        ],
        tooltipLabel: function(props) {
            var _tapAnswersById_props_id;
            return (_tapAnswersById_props_id = tapAnswersById[props.id]) === null || _tapAnswersById_props_id === void 0 ? void 0 : _tapAnswersById_props_id.option_text;
        }
    } : {
        tooltip: function(props) {
            return /*#__PURE__*/ React.createElement(CustomCrossTabTooltip, {
                barData: props,
                answersById: tapAnswersById
            });
        },
        barComponent: CustomCrossTabBarComponent,
        layers: [
            'grid',
            'axes',
            'bars',
            'markers',
            BarLegends,
            'annotations'
        ],
        legends: [
            {
                toggleSerie: true,
                dataFrom: 'indexes',
                anchor: 'left',
                direction: 'column',
                itemWidth: 1,
                itemHeight: 1
            }
        ]
    }))));
};
